import { FC, useState } from "react";
import SideBarHeader from "../common/SideBarHeader";
import {
  calendarMidSizeSVG,
  grayTrash,
  smallClockSVG,
} from "../../../assets/SVGs/SVGs";
import Service from "./Service";
import { useDispatch, useSelector } from "react-redux";
import { selectedService } from "../../../types/service";
import { Button, Form, Input, message, theme } from "antd";
import { formateTimeToAMPM, getWeekDay } from "../../../utils/DateUtils";
import { useNavigate } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import { useMutation } from "@tanstack/react-query";
import { clientValidatePromoCode } from "../../../network/clientSide";
import { setPromoCode } from "../../../services/store/slices/cart";
import { selectedPackages } from "../../../types/package";
import Package from "./Package";
import { useIntl } from "react-intl";

interface ServicesSideBarProps {}

const ServicesSideBar: FC<ServicesSideBarProps> = ({}) => {
  const dispatch = useDispatch();
  const [form] = useForm();
  const intl = useIntl();
  const [coupon, setCoupon] = useState<string | null>(null);
  const [validCoupon, setValidCoupon] = useState<boolean | null>(null);
  const url = window.location.href;
  const navigate = useNavigate();
  const { useToken } = theme;
  const {
    currentLang,
    services,
    packages,
    date,
    start_time,
    client,
    location,
    promoCode,
  } = useSelector(
    (state: {
      cart: {
        services: {
          services: selectedService[];
          packages: selectedPackages[];
          date: Date | null;
          start_time: string | null;
        };
        client: {
          phoneNumber: string | null;
          token: string | null;
          promoCode: {
            id: number;
            code: string;
            value: string;
            value_type: "percentage" | "price";
          } | null;
        };
        location: { id: number | null };
      };
      user: { currentLang: "ar" | "en" };
    }) => {
      return {
        services: state.cart.services.services,
        packages: state.cart.services.packages,
        date: state.cart.services.date,
        start_time: state.cart.services.start_time,
        client: state.cart.client,
        location: state.cart.location,
        promoCode: state.cart.client.promoCode,
        currentLang: state.user.currentLang,
      };
    }
  );
  const { mutate, isLoading } = useMutation(
    () =>
      clientValidatePromoCode(location?.id, client?.token, {
        promo_code: coupon,
      }),
    {
      onSuccess: (res: any) => {
        console.log(res?.data?.data);
        if (res?.code !== "ERR_BAD_REQUEST") {
          setValidCoupon(true);
          dispatch(setPromoCode(res?.data?.data));
        } else {
          setValidCoupon(false);
        }
      },
    }
  );
  const handleSubmit = () => {
    // if (!url.includes("auth")) {
    //   navigate("auth");
    //   return;
    // }
    if (!client?.token) {
      navigate("auth");
      return;
    }
    if (!url.includes("pick-date")) {
      navigate("pick-date");
      return;
    }
    if (!url.includes("team-members")) {
      if (!date) {
        message.error(intl.formatMessage({ id: "mustPickDate" }));
        return;
      }
      navigate("team-members");
      return;
    }
    if (!url.includes("pick-time")) {
      if (!date) {
        message.error(intl.formatMessage({ id: "mustPickDate" }));
        return;
      }
      if (!validateTeamMembers()) {
        message.error(intl.formatMessage({ id: "teamMembersRequired" }));

        return;
      }
      navigate("pick-time");
      return;
    }
    if (!url.includes("checkout")) {
      if (!date || !start_time) {
        message.error(intl.formatMessage({ id: "mustPickDateAndTime" }));
        return;
      }
      navigate("checkout");
      return;
    }
  };
  const validateCoupon = () => {
    if (!coupon) {
      message.error(intl.formatMessage({ id: "couponRequired" }));
      return;
    }
    mutate();
  };
  const validateTeamMembers = () => {
    if (services?.length === 0 && packages?.length === 0) {
      return false;
    }
    let flag: boolean = true;
    services.forEach((service) => {
      if (!service?.teamMember) {
        flag = false;
      }
    });
    packages.forEach((pkg) => {
      if (!pkg?.teamMember) {
        flag = false;
      }
    });
    return flag;
  };
  const { token } = useToken() as any;
  const urlSegments = url.split("/");
  console.log(urlSegments);
  let isAuthRoutes = false;
  let index = urlSegments.length - 1;
  if (urlSegments[urlSegments.length - 1] === "") {
    index = urlSegments.length - 2;
  }
  if (
    urlSegments[index].includes("auth") ||
    urlSegments[index].includes("register") ||
    urlSegments[index].includes("login")
  ) {
    isAuthRoutes = true;
  }
  return (
    <div className="space-y-4 max-h-[50vh]  ">
      <div
        className="flex flex-col  items-center bg-[#EEF0FF] p-4 rounded  space-y-4  w-full"
        style={{ backgroundColor: token?.defaultBg } as any}
      >
        <SideBarHeader
          title={intl.formatMessage({ id: "yourAppointment" })}
          icon={calendarMidSizeSVG(token?.colorBtnColor)}
        />
        <div className="bg-white rounded-lg p-4 w-full">
          <div className="flex flex-col justify-between gap-2 h-full">
            <div className="space-y-2">
              {date ? (
                <div className="border-[1px] border-[#EEF0FF] border-solid  border-x-0 border-t-0 p-1">
                  <div className="flex flex-wrap gap-2 items-center justify-center p-2 bg-[#FBFBFF] rounded  ">
                    <span className="translate-y-[1px]">{smallClockSVG}</span>
                    <span className="text-salon-primary font-semibold ">
                      {getWeekDay(new Date(date), currentLang)} -{" "}
                      {new Date(date).getDate()} -{" "}
                      {new Date(date).toLocaleString(currentLang, {
                        month: "long",
                      })}
                    </span>
                    {start_time ? (
                      <span className="text-color-sec-title">
                        ( {formateTimeToAMPM(start_time, currentLang)} )
                      </span>
                    ) : null}
                  </div>
                </div>
              ) : null}
              {services?.length > 0 ? (
                <div className="max-h-[52vh] overflow-auto">
                  <p className="text-salon-primary font-semibold ">
                    {intl.formatMessage({ id: "theServices" })}
                  </p>
                  {services?.map((service) => (
                    <Service key={service.id} service={service} />
                  ))}
                </div>
              ) : null}

              {packages?.length > 0 ? (
                <div className="max-h-[52vh] overflow-auto">
                  <p className="text-salon-primary font-semibold">
                    {intl.formatMessage({ id: "packages" })}
                  </p>
                  {packages?.map((pkg) => (
                    <Package key={pkg.id} packageItem={pkg} />
                  ))}
                </div>
              ) : null}
            </div>
            <div className="flex w-full justify-between gap-1 self-end">
              <p className="text-salon-primary">
                {intl.formatMessage({ id: "totalPrice" })}
              </p>
              <p>
                <span className="text-color-primary">
                  {promoCode && validCoupon
                    ? promoCode?.value_type === "price"
                      ? services.reduce((a, b) => a + +b.price, 0) +
                        packages?.reduce((a, b) => a + +b.retail_price, 0) -
                        Number(promoCode?.value)
                      : services.reduce((a, b) => a + +b.price, 0) +
                        packages?.reduce((a, b) => a + +b.retail_price, 0) -
                        services.reduce((a, b) => a + +b.price, 0) +
                        packages?.reduce((a, b) => a + +b.retail_price, 0) /
                          Number(promoCode?.value)
                    : services.reduce((a, b) => a + +b.price, 0) +
                      packages?.reduce((a, b) => a + +b.retail_price, 0)}
                </span>
                <small className="text-color-sec-title mx-1">
                  {intl.formatMessage({ id: "SAR" })}
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>
      {url.includes("checkout") ? (
        <div className="inp-no-border">
          <Form
            form={form}
            layout="vertical"
            className="w-full client-side-coupon-input "
          >
            <Form.Item name="coupon" hasFeedback={!!validCoupon}>
              <Input
                value={coupon || ""}
                addonAfter={
                  <Button
                    htmlType="button"
                    type="primary"
                    loading={isLoading}
                    onClick={() => {
                      if (validCoupon) {
                        setCoupon(null);
                        dispatch(setPromoCode(null));
                        setValidCoupon(null);
                        form.resetFields();
                      }
                      validateCoupon();
                    }}
                  >
                    {validCoupon
                      ? grayTrash
                      : intl.formatMessage({ id: "apply" })}
                  </Button>
                }
                placeholder={intl.formatMessage({ id: "enterPromoCode" })}
                onChange={(e) => setCoupon(e.target.value)}
              />
            </Form.Item>
          </Form>
        </div>
      ) : null}
      {!url.includes("checkout") && !isAuthRoutes ? (
        <div>
          <Button
            block
            size="large"
            type="primary"
            htmlType="button"
            onClick={handleSubmit}
            disabled={services?.length === 0 && packages?.length === 0}
          >
            {url.includes("checkout")
              ? intl.formatMessage({ id: "bookNow" })
              : intl.formatMessage({ id: "continue" })}
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default ServicesSideBar;
